import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import CurrencyDisplay from "../../components/CurrencyDisplay";
import { Claim } from "../../interfaces/screens/billing";
import StatusChip from "../../components/statusChip";
import { mapClaimStatusToChipStatus, mapClaimStatusToText } from "../utils/helper";
import { Edit } from "lucide-react";

interface ClaimColumnHandlers {
  onEdit: (claim: Claim) => void;
}

export const getClaimsTableColumns = (
  handlers: ClaimColumnHandlers,
): TableColumnsItem[] => [
  { key: "id", name: "Claim ID", type: ColumnType.TEXT },
  { key: "invoice_id", name: "Invoice #", type: ColumnType.TEXT },
  { key: "insurer_name", name: "Insurer", type: ColumnType.TEXT },
  {
    key: "claim_status",
    name: "Status",
    type: ColumnType.CUSTOM,
    customValue: (row: Claim) => (
      <StatusChip
        status={mapClaimStatusToChipStatus(row.claim_status)}
        label={mapClaimStatusToText(row.claim_status)}
      />
    ),
  },
  {
    key: "total_amount_billed",
    name: "Billed",
    type: ColumnType.CUSTOM,
    customValue: (row: Claim) => (
      <CurrencyDisplay amount={row.total_amount_billed} currency={"USD"} />
    ),
  },
  {
    key: "amount_covered_by_insurer",
    name: "Covered",
    type: ColumnType.CUSTOM,
    customValue: (row: Claim) => (
      <CurrencyDisplay
        amount={row.amount_covered_by_insurer}
        currency={"USD"}
      />
    ),
  },
  {
    key: "actions",
    name: "",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: Claim) => handlers.onEdit(row),
      },
    ],
  },
];

